<p-toast></p-toast>
<div class="app-verification-container">
    <p-card styleClass="p-card-shadow">
        <div class="card">

            <h5>{{'PAYMENT_DETAILS'| translate}}</h5>

            <div class="col-12">
                <div [formGroup]="fullPaymentForm" class="p-fluid p-formgrid grid">
                    <!-- <div class="field col-12 md:col-4">
                        <label htmlFor="selectProgramme">Select Programme</label>
                        <p-autoComplete placeholder="Select Programme" id="id" [dropdown]="true" [multiple]="false" field="program" value="" [suggestions]="filteredProgramme" (completeMethod)="filterProgramme($event)" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.selectProgramme.errors }"
                            formControlName="selectProgramme">
                        </p-autoComplete>
                        <div *ngIf="isSubmitted && f.selectProgramme.errors" class="invalid-feedback">
                            <div *ngIf="f.selectProgramme.errors.required">Programme is required</div>
                        </div>
                    </div> -->

                    <div class="field col-12 md:col-4">
                        <label for="icon">{{'PAYMENT_DATE'| translate}}</label>
                        <p-calendar [maxDate]="todayDate" formControlName="paymentDate" [showIcon]="true" inputId="icon" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.paymentDate.errors}"></p-calendar>
                        <div *ngIf="isSubmitted && f.paymentDate.errors" class="invalid-feedback">
                            <div *ngIf="f.paymentDate.errors.required">{{'PAYMENT_DATE_REQ'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="modeOfPayment">{{'MODE_OF_PAYMENT'| translate}}</label>
                        <!-- <p-autoComplete placeholder="Select Mode of Payment" id="id" [dropdown]="true" [multiple]="false" field="mode" value="" [suggestions]="filteredModeOfPayment" (completeMethod)="filterModeOfPayment($event)" [(ngModel)]="modeOfPaymentData" (ngModelChange)="change()"
                            formControlName="modeOfPayment" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.modeOfPayment.errors}">
                        </p-autoComplete> -->
                        <p-dropdown formControlName="modeOfPayment" [options]="modeOfPayment" optionLabel="mode" [(ngModel)]="modeOfPaymentData" (ngModelChange)="change()" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.modeOfPayment.errors}"></p-dropdown>
                        <div *ngIf="isSubmitted && f.modeOfPayment.errors" class="invalid-feedback" >
                            <div *ngIf="f.modeOfPayment.errors.required">{{'MODE_OF_PAYMENT_REQ'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="amount">{{'AMOUNT'| translate}}</label>
                        <input pInputText id="amount" type="number" placeholder="{{'AMOUNT'| translate}}" [(ngModel)]="amount" formControlName="amount" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.amount.errors}" />
                        <div *ngIf="isSubmitted && f.amount.errors" class="invalid-feedback">
                            <div *ngIf="f.amount.errors.required">{{'AMOUNT_REQ'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4" *ngIf="isReference">
                        <label htmlFor="referenceNo">{{'REFERENCE_NO'| translate}}</label>
                        <input pInputText id="referenceNo" type="text" placeholder="{{'REFERENCE_NO'| translate}}" [(ngModel)]="referenceNo" formControlName="referenceNumber" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.referenceNumber.errors}" />
                        <div *ngIf="isSubmitted && f.referenceNumber.errors" class="invalid-feedback">
                            <div *ngIf="f.referenceNumber?.errors?.required">{{'REFERENCE_REQ'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="accountNo">{{'ACCOUNT_NUMBER'| translate}}</label>
                        <input pInputText id="accountNo" type="number" placeholder="{{'ACCOUNT_NUMBER'| translate}}" [(ngModel)]="accountNo" formControlName="accountNumber" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.accountNumber.errors}" />
                        <div *ngIf="isSubmitted && f.accountNumber.errors" class="invalid-feedback">
                            <div *ngIf="f.accountNumber.errors.required">{{'ACCOUNT_NO_REQ'| translate}}</div>
                        </div>
                    </div>

                </div>

                <div class="field-checkbox">
                    <p-checkbox [(ngModel)]="paymentCheckBox" [binary]="true" inputId="binary"></p-checkbox>
                    <label for="binary">{{'PAYMENT_CHECKBOX'| translate}}</label>
                </div>
                <div class="field-checkbox">
                    <div *ngIf="isSubmitted && !paymentCheckBox" class="invalid-feedback">
                        <p>{{'CLICK_THE_CHECKBOX'| translate}}</p>
                    </div>
                </div>
                
                <div>
                    <button (click)="submitPaymentDetails()" pButton pRipple type="submit" label="{{'SUBMIT_PAYMENT_DETAILS'| translate}}" class="p-button-success mr-2 mb-2"></button>
                </div>

            </div>
        </div>
    </p-card>
</div>
